import { BaseApi } from '../base-api';

export class ChannelsActivityApi extends BaseApi {
  protected readonly version = '2';
  protected readonly prefix = 'license/channels';

  fetch = () => this.get();
}
